import React, { useState } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import Modal from './modal'
import img1 from '../asset/img1.jpeg';
import img2 from '../asset/img2.jpeg';
import img3 from '../asset/img3.jpeg';





const Memories = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const close = () => setModalOpen(false);
    const open = () => setModalOpen(true);

    return (
        <section className='container grid mx-auto py-12 px-4 warna overflow-hidden md:px-12 md:gap-6'>
            <h1
                className="font-marck text-3xl tracking-tight mb-6 md:text-4xl">
                Our Memories
            </h1>
            <div className='grid gap-8 px-4 md:grid-cols-2'>
                <figure className='bg-white p-4 -rotate-6'>
                    <img src={img1} className='w-full' alt="memory" />
                </figure>
                <figure className='bg-white p-4 rotate-3'>
                    <img src={img2} className='w-full' alt="memory" />
                </figure>
                <figure className='bg-white p-4 -rotate-6 md:rotate-6'>
                    <img src={img3} className='w-full' alt="memory" />
                </figure>
            </div>

            <div className='font-indie text-base text-center mt-8'>
                <motion.button
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    onClick={() => (modalOpen ? close() : open())}
                    className='inline-grid bg-[#B5FFFC] px-6 py-2 rounded-lg'>
                    Click me
                </motion.button>

                <AnimatePresence
                    initial={false}
                    exitBeforeEnter={true}
                    onExitComplete={() => null}>

                    {modalOpen && <Modal modalOpen={modalOpen} handleClose={close}></Modal>}
                </AnimatePresence>

            </div>
        </section>
    )
}

export default Memories;